import * as TagUtil from 'schemas/tags/TagUtil';

import {RequestTask, ServerRequestTask, ServerUIRequestTask, UIRequestTask} from './RequestTaskConstants';

function prepareRequestTasksForServer(requestTasks: Array<RequestTask>): Array<ServerRequestTask>;
function prepareRequestTasksForServer(requestTasks: Array<UIRequestTask>): Array<ServerUIRequestTask>;
function prepareRequestTasksForServer(
  requestTasks: Array<RequestTask | UIRequestTask>
): Array<ServerRequestTask | ServerUIRequestTask> {
  return requestTasks.map((requestTask) => ({
    ...requestTask,
    tags: TagUtil.getTagsToSet(requestTask.tags),
  }));
}

export default prepareRequestTasksForServer;
